window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};
window.BSS_B2B = window.BSS_B2B || {};
window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};
const funcHandle = ({ a, b, c}) => {
  // handle something
};
window.BSS_B2B.addAction("handleSomething", funcHandle ); 

window.BSS_B2B.addAction("custom:TdProductList/showPrice", function ({ element, BSS_B2B }) {
  console.log('element')
    const variantId =
      element.getAttribute("bss-b2b-variant-id") ||
      element.closest("[data-variant-id]")?.getAttribute("data-variant-id");

    if (!variantId) return;

    const variant = BSS_B2B.storage.variantStorage.get(Number(variantId));
    if (!variant?.appliedTD) return;
    const { priceHasVat, priceNoVat, comparePriceHasVat, comparePriceNoVat } =
      BSS_B2B.td.utils.productList.getPriceHtml(
        variant.appliedTD,
        variant.bssB2BPriceAfterTD,
        1
      );

    if ((comparePriceHasVat || comparePriceNoVat) &&
        (variant.appliedCP || variant.appliedPL)) {
      element.innerHTML =
        comparePriceNoVat + comparePriceHasVat + priceNoVat + priceHasVat + '.';
    } else {
      element.innerHTML = priceNoVat + priceHasVat;
    }
  }
);

// update full variant in storage
const customPrepareDiscountPrices = (products) => {
    if (!BSS_B2B.page.isCollectionPage()) return products;
    const CP_KEY = 'cp';
    const PL_KEY = 'pl';
    if (BSS_B2B.cp.status) {
        for (const product of products) {
            product.variants.forEach((variant, ind) => {
                const appliedRule = BSS_B2B.cp.utils.common.getCustomerAppliedRules().find(rule => BSS_B2B.cp.utils.common.checkProduct(rule, {
                    ...product,
                    currentVariant: variant
                }));
                if (appliedRule) {
                    product.variants[ind].appliedCP = appliedRule;
                    const {
                        discount_type,
                        discount_value
                    } = appliedRule;
                    const modifiedPrice = BSS_B2B.cp.utils.common.calculateDiscount(variant.price, discount_type, Number(discount_value));
                    if (modifiedPrice !== variant.price) {
                        product.variants[ind].bssB2BPriceAfterCP = modifiedPrice;
                        product.variants[ind].bssB2bShowPriceKey = BSS_B2B.utils.getModuleKeyByPriority(variant.bssB2bShowPriceKey, CP_KEY);
                        product.bssB2bShowPriceKey = BSS_B2B.utils.getModuleKeyByPriority(product.bssB2bShowPriceKey, CP_KEY);
                    } else {
                        delete variant.appliedCP;
                        delete variant.bssB2BPriceAfterCP;
                        if (variant.bssB2bShowPriceKey === CP_KEY) {
                            delete variant.bssB2bShowPriceKey;
                        }
                        if (product.bssB2bShowPriceKey === CP_KEY) {
                            delete product.bssB2bShowPriceKey;
                        }
                    }
                    BSS_B2B.storage.variantStorage.set(variant.id, variant);
                    BSS_B2B.storage.productStorage.set(product.id, product);
                }
            })
        }
    }
    if (BSS_B2B.pl.status) {
        for (const product of products) {
            product.variants.forEach((variant, ind) => {
                const appliedRule = BSS_B2B.pl.utils.common.getCustomerAppliedRules().find(rule => BSS_B2B.pl.utils.common.checkProduct(rule, {
                    ...product,
                    currentVariant: variant
                }));
                if (appliedRule) {
                    let discount_type, discount_value;
                    if (appliedRule.selected_products) {
                        product.variants[ind].appliedPL = appliedRule;
                        const discount = appliedRule.selected_products.find(item => item.product_id == product.id);
                        if (discount) {
                            discount_type = discount.discount_type;
                            discount_value = discount.discount_value;
                        }
                    } else if (appliedRule.selected_variants) {
                        const discount = appliedRule.selected_variants.find(item => item.variant_id == variant.id);
                        if (discount) {
                            discount_type = discount.discount_type;
                            discount_value = discount.discount_value;
                        }
                    }
                    const modifiedPrice = BSS_B2B.pl.utils.common.calculateDiscount(variant.price, discount_type, Number(discount_value));
                    if (modifiedPrice !== variant.price) {
                        variant.productId = product.id;
                        product.variants[ind].bssB2BPriceAfterPL = modifiedPrice;
                        product.variants[ind].bssB2bShowPriceKey = BSS_B2B.utils.getModuleKeyByPriority(variant.bssB2bShowPriceKey, PL_KEY);
                        product.bssB2bShowPriceKey = BSS_B2B.utils.getModuleKeyByPriority(product.bssB2bShowPriceKey, PL_KEY);
                    } else {
                        delete variant.appliedPL;
                        delete variant.bssB2BPriceAfterPL;
                        if (variant.bssB2bShowPriceKey === PL_KEY) {
                            delete variant.bssB2bShowPriceKey;
                        }
                        if (product.bssB2bShowPriceKey === PL_KEY) {
                            delete product.bssB2bShowPriceKey;
                        }
                    }
                    BSS_B2B.storage.variantStorage.set(variant.id, variant);
                    BSS_B2B.storage.productStorage.set(product.id, product);
                }
            })
        }
    }
    return products;
}
window.BSS_B2B.addFilter('custom:prepareDiscountPrices', customPrepareDiscountPrices); 

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      for (let item of MutationList) {
        if (item.target.classList?.contains('cart-item__selling-price')) {
          window.dispatchEvent(new Event("scroll"));
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
}, 300);
}

document.addEventListener("DOMContentLoaded", function() {
  const isProductPage = (
    typeof BSS_B2B !== "undefined" &&
    BSS_B2B.page &&
    BSS_B2B.page.isProductPage()
  );

  const qvBtns = document.querySelectorAll(".btn.btn--secondary.quickbuy-toggle");

  qvBtns.forEach(qvBtn => {
    qvBtn.addEventListener("click", function() {
      setTimeout(() => {
        const forms = document.querySelectorAll(".product-form.theme-init");

        forms.forEach(function(form) {
          if (!isProductPage) {
            form.removeAttribute("bss-b2b-main-product-form");
            form.setAttribute("bss-b2b-quickview-product-form", "");
            document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
          }
        });
      }, 3000);
    });
  });
});

let counter = 0;
const selector = ".product-block[data-variant-id]";

const interval = setInterval(() => {
  const elements = document.querySelectorAll(selector);

  if (elements.length) {
    console.log("product-block đã xuất hiện");
    clearInterval(interval);

    elements.forEach(productBlock => {
      const variantId = productBlock.getAttribute('data-variant-id');
      if (!variantId) return;

      const prices = productBlock.querySelectorAll(
        '.product-price__item.product-price__amount'
      );

      prices.forEach(price => {
        price.setAttribute('bss-b2b-variant-id', variantId);
      });
    });
  } else {
    counter += 100;
    if (counter >= 10000) {
      clearInterval(interval);
    }
  }
}, 100);
